import { TemplateRef } from '@angular/core';

export class Column {
  title?:           string;
  titleRef?:        string;
  field:            string;
  type?:            string;
  searchable?:      boolean;
  sortable?:        boolean;
  filterType?:      number;
  filterOptions?:   any;
  cellOptions?:     any;
  headerTemplate?:  any;
  bodyTemplate?:    TemplateRef<any>;
  filterTemplate?:  TemplateRef<any>;
  filterChars?:     number;
  maxFilterChars?:  number;
  textAlignment?:   string;
}

export class Group {
  title?:     string;
  titleRef?:  string;
  name:       string;
  from:       string;
  to:         string;
}

export class Filter {
  offset:     number;
  limit:      number;
  sort?:      string;
  sort_dir?:  number;
  global?:    string;
  search?:    Array<any>;
}

export class CRUDNames {
  list: string;
  sendExtSearchQuery?: string;
}

export class KonPermission {
  create =  true;
  edit =    true;
  view =    true;
  delete =  true;
}

export enum REPORT_TYPE {
  STANDARD = 'STANDARD',
  DATE = 'DATE',
  TIME = 'TIME',
  DATE_TIME = 'DATE_TIME',
}

export enum REPORT_ALIGNMENT {
  LEFT = 'left',
  RIGHT = 'right',
  CENTER = 'center',
}



// WEBPACK FOOTER //
// ./src/app/modules/UIKit/components/kontable/utility/utility-model.ts